import API from "@aws-amplify/api";
import {
  createDatabaseConnection,
  deleteDatabaseConnection,
  updateDatabaseConnection,
} from "../../graphql/mutations";
import {
  connectionsByWorkspace,
  getDatabaseConnection,
} from "../../graphql/queries";
import { makeGraphQLRequest } from "..";
const createDatabaseConnection_ = async (object) => {
  return makeGraphQLRequest({
    query: createDatabaseConnection,
    variables: { input: object },
  });
};
const getDatabaseConnection_ = async (id) => {
  return makeGraphQLRequest({
    query: getDatabaseConnection,
    variables: { id },
  });
};
const updateDatabaseConnection_ = async (id, _properties = {}) => {
  const original = await getDatabaseConnection_(id);
  return makeGraphQLRequest({
    query: updateDatabaseConnection,
    variables: {
      input: {
        id,
        _version: original?.data?.getDatabaseConnection?._version,
        ..._properties,
      },
    },
  });
};

const deleteDatabaseConnection_ = async (id) => {
  const original = await getDatabaseConnection_(id);
  return makeGraphQLRequest({
    query: deleteDatabaseConnection,
    variables: {
      input: {
        id,
        _version: original?.data?.getDatabaseConnection?._version,
      },
    },
  });
};

const getDatabaseConnections_ = async (workspaceID, nextToken) => {
  return makeGraphQLRequest({
    query: connectionsByWorkspace,
    variables: {
      workspaceID,
      nextToken,
    },
  });
};

export default {
  createDatabaseConnection: createDatabaseConnection_,
  updateDatabaseConnection: updateDatabaseConnection_,
  deleteDatabaseConnection: deleteDatabaseConnection_,
  getDatabaseConnection: getDatabaseConnection_,
  getDatabaseConnections: getDatabaseConnections_,
};
